type FormatTimeProps = {
  /**
   * Time **in seconds**
   */
  time: number;

  /**
   * When set to true, it adds 0 when minutes less than 10
   */
  leadingZero?: true;
};

export const formatNumber = (value: number, leadingZero?: boolean) => {
  if (leadingZero && value < 10) {
    return `0${value}`;
  }
  return value;
};

const FormatTime = ({ time, leadingZero }: FormatTimeProps) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return (
    <>
      {formatNumber(minutes, leadingZero)}:{formatNumber(seconds, true)}
    </>
  );
};

export default FormatTime;
